module.exports = __webpack_public_path__ + "static/media/tournifyLoader.fa5e5f53.png";